import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useIconPalette } from "@plansoft-configuration-renderer/components";

export interface CustomSubconfigurationNavigationButtonsProps {
  onResetClicked(): void;
  onNextClicked(): void;
  onPreviousClicked(): void;
  nextDisabled: boolean;
  previousDisabled: boolean;
  resetDisabled: boolean;
}

export function CustomSubconfigurationNavigationButtons(
  props: CustomSubconfigurationNavigationButtonsProps,
): JSX.Element {
  const { t } = useTranslation();
  const Icons = useIconPalette();
  return (
    <Box
      sx={{
        py: 1,
      }}
    >
      <Button
        onClick={props.onPreviousClicked}
        disabled={props.previousDisabled}
      >
        <Icons.PrevIcon /> {t("WEG:subconfigurationNavigation.previousItem")}
      </Button>
      <Button onClick={props.onNextClicked} disabled={props.nextDisabled}>
        <Icons.NextIcon /> {t("WEG:subconfigurationNavigation.nextItem")}
      </Button>
    </Box>
  );
}
